<script lang="ts">
    import Fa from "svelte-fa";
    import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

    import PuzzleRow from "./PuzzleRow.svelte";
    import { DARK_PALETTE } from "../utils/color";
    import type { ConstraintDescriptor, Puzzle } from "../types";

    export let puzzle: Puzzle;
    export let constraints: ConstraintDescriptor[];
    export let onFeatsChange: (feats: string[][]) => void;

    let featNames: string[];
    let feats: string[][];

    $: {
        featNames = puzzle.featNames;
        feats = puzzle.feats;
    }

    let showInfoTooltip: boolean = false;

    const onFeatRowChange = (featRow: string[], i: number) => {
        const nextFeats = [...feats];
        nextFeats[i] = featRow;
        onFeatsChange(nextFeats);
    };
</script>

<div class="root-container">
    <div class="header-container">
        <div
            class="info-icon"
            on:mouseenter={() => (showInfoTooltip = true)}
            on:mouseleave={() => (showInfoTooltip = false)}
        >
            <Fa icon={faCircleInfo} />
            {#if showInfoTooltip}
                <div class="tooltip-content">
                    Drag nodes to modify the current solution.
                </div>
            {/if}
        </div>
        <span class="font-size-20">Solution</span>
    </div>

    {#each featNames as featName, i}
        <PuzzleRow
            featColor={DARK_PALETTE[i]}
            {featName}
            feats={feats[i]}
            withEdge={i !== featNames.length - 1}
            {constraints}
            onFeatsChange={(featRow) => onFeatRowChange(featRow, i)}
        />
    {/each}
</div>

<style lang="scss">
    @use "common.scss";
    @import "theme.scss";

    .root-container {
        padding: 1.618rem;
        border-radius: 1.618rem;
        background: lighten($background, 5%);
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        align-items: center;
    }

    .header-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 1rem;
        position: relative;
    }

    .info-icon {
        position: absolute;
        top: 0.2rem;
        left: 0.25rem;
    }

    .tooltip-content {
        position: absolute;
        top: calc(100% + 1rem);
        left: -1rem;
        z-index: 100;
        width: 200px;
        border-radius: 16px;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        padding: 0.5rem;
        box-shadow: 0px 0px 8px -1px black;
        background: $background;
    }

    :global(.edit-btn) {
        margin-bottom: 0px !important;
    }

    :global(.edit-btn div) {
        margin-left: 0px !important;
    }
</style>
